import { getEmbeddedSamplePath } from "../../views/App/urls";
import { FeatureAnchor } from "../PaperShared/Sample";

import "./FeatureDependencies.scss";

function FeatureDependencies() {
  const modelId = "baby-v1";
  const sampleId = "1026879";
  const featureKey = "2.1.2713";
  const embeddedSamplePath = `#${getEmbeddedSamplePath(modelId, sampleId, featureKey)}`;

  return (
    <section id="FeatureDependenciesV1">
      <figure>
        <figcaption>
          <span>
            Upstream Dependencies through{" "}
            <FeatureAnchor modelId={modelId} sampleId={sampleId} featureKey={featureKey} />
          </span>
        </figcaption>
        <iframe title="Embedded Circuit" src={embeddedSamplePath} height="310px" />

        <ul className="list">
          <li>
            <div>
              <span className="label">
                <span className="feature-number">2875</span> :
              </span>
              <span className="description">
                Feature number. Each layer contains up to 6144 features. In this document, features
                may be prefixed with a layer number (e.g., 2.2875).
              </span>
            </div>
          </li>
          <li>
            <div>
              <span className="label">
                <span className="lighter-feature">4757</span> :
              </span>
              <span className="description">
                Lighter features are less strongly activated than bolded features.
              </span>
            </div>
          </li>
          <li>
            <div>
              <span className="label">
                <span className="highlighted-feature">2713</span> :
              </span>
              <span className="description">Highlighted feature</span>
            </div>
          </li>
          <li>
            <div>
              <span className="label">
                <span className="dependent-feature">2594</span> :
              </span>
              <span className="description">
                A feature that either depends upon or is dependent on the highlighted feature
              </span>
            </div>
          </li>
          <li>
            <div>
              <span className="label">
                <span className="weakly-iteracting-feature">3804</span> :
              </span>
              <span className="description">
                A lighter background indicates a weaker feature interaction (i.e., muted ablation
                effect).
              </span>
            </div>
          </li>
        </ul>
      </figure>
    </section>
  );
}

export { FeatureDependencies };
